import dayjs from 'dayjs'
import { encode } from 'iconv-lite'
import _ from 'lodash'
import * as React from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

import { showError } from 'slices/notificationSlice'
import { selectPlansStatus } from 'slices/plansSlice'
import { selectScheduleTypesStatus } from 'slices/scheduleTypesSlice'

import { connectionTypes, exportData } from 'components/common/utils'

const useTargetsImport = () => {
  const { workspaceId } = useParams<'workspaceId'>()
  const { partialScheduleTypes } = useSelector(selectScheduleTypesStatus, shallowEqual)
  const { planList } = useSelector(selectPlansStatus, shallowEqual)
  const dispatch = useDispatch()

  const header = React.useMemo(
    () => [
      '日付',
      ...partialScheduleTypes.filter(s => s.connectionType !== connectionTypes.None).map(s => `${s.name}[${s.id}]`),
    ],
    [partialScheduleTypes]
  )

  const exportToCSV = React.useCallback(
    (body: string[][], fileName: string) => {
      const csvData = [header, ...body].map(r => r.join(',')).join('\n')
      const csvDataShiftJIS = encode(csvData, 'Shift_JIS')
      const blob = new Blob([csvDataShiftJIS], { type: 'text/csv' })
      exportData(blob, fileName)
    },
    [header]
  )

  const handleDataFormat = React.useCallback(() => {
    exportToCSV([], '作業目標データフォーマット.csv')
  }, [exportToCSV])

  const formatDate = React.useCallback((date: string) => dayjs(date, 'YYYY-MM-DD').format('YYYY/MM/DD'), [])

  const exportTargets = React.useCallback(
    (date?: string) => {
      if (!planList || !partialScheduleTypes) {
        dispatch(showError())
        return
      }

      const targetScheduleTypeIds = partialScheduleTypes
        .filter(s => s.connectionType !== connectionTypes.None)
        .map(s => s.id)
      const rows = _.sortBy(planList.dailyPlans, o => new Date(o.workDate).getTime())
        .filter(p => p.workerCount > 0 && (!date || p.workDate === date))
        .map(p => ({ ...p, data: p.data.filter(d => targetScheduleTypeIds.includes(d.scheduleTypeId)) }))
        .map(p => [formatDate(p.workDate), ..._.sortBy(p.data, 'scheduleTypeName').map(d => d.target.toString())])

      exportToCSV(rows, `target-${workspaceId}-${dayjs().format('YYYY-MM-DD-HHmm')}.csv`)
    },
    [dispatch, exportToCSV, formatDate, partialScheduleTypes, planList, workspaceId]
  )

  return { handleDataFormat, exportTargets, formatDate }
}
export default useTargetsImport
